
// const user = window.location.toString().split('/')[3]
export const getConfigDetails = () => {
  // switch ('demo') {
    // switch ('preStage') {
      // switch ('staging') {
      // switch ('preprod') {
    switch ('live') {
    case 'demo': //staging2
      return {
        // baseURL: 'https://demo-api.parkengage.com/',
        // PARTNER_ID: PARTNER_ID,
        // CLIENT_SECRET: CLIENT_SECRET,

        baseURL: 'https://demo-api.parkengage.com/',
        adminUrl: 'https://demo-admin.parkengage.com',
        checkInUrl: 'https://demo-checkin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com/navigating',
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: '358811',
        CLIENT_SECRET: 'DMqZtiWQw1tvzhJ908MR1MQjb',
        CLIENT_ID: 'diamond-parking358811'
      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        checkInUrl: 'https://pre-stage-checkin.parkengage.com',
        adminUrl: 'https://pre-stage-admin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com/navigating',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: '358811',
        CLIENT_SECRET: 'DMqZtiWQw1tvzhJ908MR1MQjb',
        CLIENT_ID: 'diamond-parking358811'
      }
    case 'staging': //staging
      return {
        // baseURL: 'https://staging-api.parkengage.com/',
        // FACILITY_ID: 1,
        // FULL_SEASON: '502',
        // HALF_SEASON: '506',
        // SIX_PACK: '507',
        // CLIENT_SECRET: CLIENT_SECRET,

        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        checkInUrl: 'https://staging-checkin.parkengage.com',
        transientURL: 'https://staging-transient.parkengage.com',
        portalURL: 'https://staging-customerportal.parkengage.com/navigating',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: '358811',
        CLIENT_SECRET: 'DMqZtiWQw1tvzhJ908MR1MQjb',
        CLIENT_ID: 'diamond-parking358811'
      }
    case 'preprod': //staging
      return {
        // baseURL: 'https://staging-api.parkengage.com/',
        // FACILITY_ID: 1,
        // FULL_SEASON: '502',
        // HALF_SEASON: '506',
        // SIX_PACK: '507',
        // CLIENT_SECRET: CLIENT_SECRET,

        baseURL: 'https://preprod-api.parkengage.com/',
        adminUrl: 'https://preprod-admin.parkengage.com',
        checkInUrl: 'https://preprod-checkin.parkengage.com',
        transientURL: 'https://preprod-transient.parkengage.com',
        portalURL: 'https://preprod-customerportal.parkengage.com/navigating',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: '3156',
        CLIENT_SECRET: 'tbbeW0uXA4XurO4kgDnqD4rao',
        CLIENT_ID: 'diamond-parking3156',
      }
    case 'live': //live
      return {
        // baseURL: 'https://api.parkengage.com/',
        // FACILITY_ID: 32,
        // FULL_SEASON: '80',
        // HALF_SEASON: '81',
        // SIX_PACK: '82',
        // CLIENT_SECRET: CLIENT_SECRET,

        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://partner.parkengage.com',
        checkInUrl: 'https://checkin.parkengage.com',
        transientURL: 'https://transient.parkengage.com',
        portalURL: 'https://customerportal.parkengage.com/navigating',
        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: '3156',
        CLIENT_SECRET: 'tbbeW0uXA4XurO4kgDnqD4rao',
        CLIENT_ID: 'diamond-parking3156',
      }
  }
}
